import React, { Component } from 'react';
import { FaPlusCircle } from 'react-icons/fa';
import { DashboardTabWrapper, DashboardTab, AddTabButton } from './DashboardTabs.styles';

class DashboardTabs extends Component {
  state = {
    orderedDashboard: [],
    insertTo: null,
    isSavingOrder: false,
  }

  componentDidMount() {
    // This removes the dragEnd animation of tab flying back to its original position.
    document.addEventListener('dragover', (e) => { e.preventDefault(); });
    this.orderingDashboardTabs();
  }

  componentDidUpdate(prevProps) {
    const { dashboards } = this.props;
    const { orderedDashboard } = this.state;
    if (
      orderedDashboard !== dashboards
      && prevProps.dashboards !== dashboards
    ) {
      this.orderingDashboardTabs();
    }
  }

  orderingDashboardTabs = () => {
    const { dashboards } = this.props;
    this.setState({
      orderedDashboard: dashboards ? dashboards.sort((a, b) => (a.order - b.order)) : [],
    });
  }

  dragStart = (event) => {
    const { currentTarget, dataTransfer } = event;
    this.dragged = {
      target: currentTarget,
      pk: Number(currentTarget.dataset.pk),
      width: currentTarget.offsetWidth,
      index: Array.prototype.indexOf
        .call(currentTarget.parentElement.children, currentTarget),
    };

    // Firefox requires calling dataTransfer.setData
    // for the drag to properly work
    if (navigator.userAgent.indexOf('Firefox') !== -1) {
      dataTransfer.setData('text/html', null);
    }
    // Debounce is needed here otherwise dragging won't work.
    // This hides the original drag item, not the one that is moving along
    // with the cursor.
    setTimeout(() => this.dragged.target.setAttribute('hidden', true), 10);
  }

  dragEnter = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const over = event.currentTarget;
    this.setState({ insertTo: over && Number(over.dataset.pk) });
    this.clearDropZone();
    this.createDropZone(over, this.dragged.width);
  }

  dragEnd = (event) => {
    event.preventDefault();
    const { api: { updateDashboard, resetDashboard } } = this.props;
    const { orderedDashboard, insertTo } = this.state;
    const items = orderedDashboard;
    const clearDrag = () => {
      this.dragged.target.removeAttribute('hidden');
      this.dragged = undefined;
    };

    if (insertTo !== null) {
      this.setState({ isSavingOrder: true });
      const dragDashboard = items[this.dragged.index];
      const overDashboard = items.find(dashboard => dashboard.pk === insertTo);
      dragDashboard.order = overDashboard.order;
      // The backend will just need to grab the order of "over" and will perform
      // re-ordering in backend.
      updateDashboard(
        dragDashboard.pk,
        dragDashboard,
        (activeDashboard) => {
          resetDashboard(activeDashboard);
          this.clearDropZone();
          clearDrag();
          this.setState({ isSavingOrder: false });
        },
      );
    } else {
      clearDrag();
    }

    this.setState({ insertTo: null });
  }

  createDropZone = (node, width) => node.setAttribute('style', `margin-left: ${width}px;`);

  clearDropZone = () => { // Since dropzone is created via injecting a style, remove it.
    [].slice.call(document.querySelectorAll('#DCRPDashboardTab div'))
      .forEach(item => item.removeAttribute('style'));
  }

  render() {
    const {
      activeDashboard,
      setActiveDashboard,
      addDashboard,
      disableDashCreation = false,
    } = this.props;

    const { orderedDashboard, insertTo, isSavingOrder } = this.state;
    const isSortOrdering = (insertTo !== null) || isSavingOrder;

    return (
      <DashboardTabWrapper width="1" bg="greyscale.4" id="DCRPDashboardTab">
        {orderedDashboard.map(
          (dashboard) =>
            dashboard && (
              <DashboardTab
                key={dashboard.pk}
                px={1}
                mx="1px"
                active={dashboard.pk === activeDashboard}
                // TODO: when colours in mock data are proper hex codes change.
                bg={dashboard.colour}
                color="greyscale.5"
                onClick={() => setActiveDashboard(dashboard.pk)}
                draggable={!isSavingOrder}
                onDragStart={this.dragStart}
                onDragEnter={this.dragEnter}
                onDragEnd={this.dragEnd}
                isSortOrdering={isSortOrdering}
                data-pk={dashboard.pk}
              >
                <p>{dashboard.name}</p>
              </DashboardTab>
            )
        )}
        {!disableDashCreation && (
          <AddTabButton mx={0} color="greyscale.2" onClick={addDashboard}>
            <FaPlusCircle />
          </AddTabButton>
        )}
      </DashboardTabWrapper>
    );
  }
}

export default DashboardTabs;
